import Hyperlink from "../ui/hyperlink";
import Image from "next/image";

interface Props {
    title: string;
    description: string;
    btn: string;
    href: string;
    features: string[];
    style?: string;
}

const Hero = ({ title, description, btn, href, features, style }: Props) => {
    return (
        <>
            <section className={`desilo-hero-service-section ${style && style === 'style-1' ? '' : 'section-padding-bottom'} overflow-hidden`}>
                <div className="container custom-container">
                    <div className="row g-4">
                        <div className="col-lg-12 col-xxl-10">
                            <div className="desilo-hero-service__content desilo-hero5__info">
                                <h1 className="title">{title}</h1>
                                {
                                    description && (
                                        <p className="hero2-content-text text-color-primary">{description}</p>
                                    )
                                }
                                {btn && (
                                    <div className="row">
                                        <div className="col-12 text-left">
                                            <Hyperlink href={href} variant="primary">
                                                {btn}
                                            </Hyperlink>
                                        </div>
                                    </div>
                                )}
                                {
                                    features && features.length > 0 && (
                                        <div className="trusted-by-section col-lg-5 d-flex flex-column justify-content-end">
                                            <div className="trusted-by-content">
                                                <div className="trusted-by-images">
                                                    <Image src="/images/hero/common-hero-thumb.png" alt="Client 1" width={50} height={50} />
                                                    <Image src="/images/hero/common-hero-thumb.png" alt="Client 2" width={50} height={50} />
                                                    <Image src="/images/hero/common-hero-thumb.png" alt="Client 3" width={50} height={50} />
                                                    <Image src="/images/hero/common-hero-thumb.png" alt="Client 4" width={50} height={50} />
                                                    <Image src="/images/hero/common-hero-thumb.png" alt="Client 5" width={50} height={50} />
                                                </div>
                                                <div className="trusted-by-text">
                                                    <p>Trusted by 25+ funded startups from Seed to Series B</p>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default Hero;
